function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 3.2v1.5c0 .5.2 1 .5 1.4l2 2.5c.6.8.6 2 0 2.8l-2 2.5c-.3.4-.5.9-.5 1.4v3.2c0 .2.3.5.6.5h9.9c.3 0 .6-.3.6-.6v-3.2c0-.5-.2-1-.5-1.4l-2-2.5c-.6-.8-.6-2 0-2.8l2-2.5c.2-.3.4-.8.4-1.3V1.6c0-.3-.3-.6-.6-.6H5.6c-.3 0-.6.3-.6.6V3.2zM8.1 3h4.7c1 0 1.5 1.1.9 1.9l-2.4 2.8c-.4.5-1.3.5-1.7 0L7.3 4.9c-.7-.8-.1-1.9.8-1.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgHourglass;